import {createFileRoute} from "@tanstack/react-router";
import {ProfileQuest} from "@/components/profile/quest/ProfileQuest";

export const Route = createFileRoute("/_mainLayout/profile/quest/")({
  component: ProfileQuest,
});
